import { CSS, StyleProps } from "@shared/primitive-components"

export const root = (): CSS => ({
  padding: 0,
})

export const item = (color?: "red" | "green") => (props: StyleProps) => {
  const itemStyle: { padding: string; color?: string } = {
    padding: props.theme.spacing(2, 0),
  }
  if (color) {
    const { red, green } = props.theme.palette.full
    itemStyle.color = color === `red` ? red : green
  }
  return itemStyle
}

const getTextCSS = (isTitle?: boolean): CSS | undefined =>
  !isTitle
    ? {
        flex: 1,
        textAlign: `right`,
      }
    : undefined

export const makeTextStyle =
  (bold: boolean, isTitle?: boolean) =>
  (props: StyleProps): CSS => ({
    ...getTextCSS(isTitle),
    fontFamily: bold ? props.theme.fonts.subHeading.fontFamily : props.theme.fonts.body.fontFamily,
    fontWeight: bold ? props.theme.fonts.subHeading.fontWeight : props.theme.fonts.body.fontWeight,
    color: isTitle ? props.theme.palette.grey.dark : `inherit`,
    lineHeight: props.theme.typography.body.lineHeight,
    textTransform: isTitle || bold ? `uppercase` : `none`,
  })
